import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import ProductList from '../ProductListView/ProductList';
import ProductGrid from '../ProductGridView/ProductGrid';
import UISettings from '../../settings/UISettings';
import { getActiveListingPage } from '../../reduck/selectors';


const DivResultListWrapper = styled.div` 
  display: block;
  border-top: 0;
`;


const sharedAttrs = {
  'data-component': 'product-list-view',
  'className': 'col12'
};

function ProductListing({ containsProducts, activeView }) {
  if (!containsProducts) {
    return null;
  }
  return activeView === 'list'
    ? (
      <DivResultListWrapper {...sharedAttrs} className={`${sharedAttrs.className} resultList`}>
        <ProductList />
      </DivResultListWrapper>
    )
    : (
      <div {...sharedAttrs} className={`${sharedAttrs.className} resultGrid`}>
        <ProductGrid />
      </div>
    );
}

ProductListing.propTypes = {
  containsProducts: PropTypes.bool.isRequired,
  activeView: PropTypes.oneOf(['grid', 'list'])
};
ProductListing.defaultProps = {
  activeView: 'list'
};

const mapStateToProps = (state) => ({
  containsProducts: getActiveListingPage(state).productList.length > 0,
  activeView: state.listingPage.commonData.selectedUserView || UISettings.get('defaultViewForThisSegment') ||
    UISettings.get('defaultView')
});

export default connect(mapStateToProps)(ProductListing);
